import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Config
import styles from "../../config/styles";

// Components
import CollapseInjuries from "./CollapseInjuries";
import CollapsePhysicalDamage from "./CollapsePhysicalDamage";
import SelectDevice from "./SelectDevice";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border,
    overflow: "hidden",
    marginBottom: theme.spacing(1)
  }
}));

const CaseInjuriesPanel = ({ data, isWitness }) => {
  const classes = useStyles();

  if (!data || isWitness) return null;

  return (
    <Paper elevation={0} className={classes.root}>
      <CollapseInjuries injuries={data.injuries} caseId={data.id} />
      <CollapsePhysicalDamage caseId={data.id} />
      <SelectDevice />
    </Paper>
  );
};

CaseInjuriesPanel.propTypes = {
  data: PropTypes.shape({
    creationDateTime: PropTypes.string,
    id: PropTypes.string,
    injuries: PropTypes.arrayOf(PropTypes.shape({})),
    isDraft: PropTypes.bool,
    number: PropTypes.string,
    patientName: PropTypes.string
  }),
  isWitness: PropTypes.bool.isRequired
};

CaseInjuriesPanel.defaultProps = {
  data: {}
};

export default CaseInjuriesPanel;
